import {DropdownItem, FormControl, showNotification} from 'platform/components';

import {UseFormReturn} from 'react-hook-form';

import {isEmpty} from 'ramda';

import {
  ContextTemplateResponseBody,
  GetContextTemplateListApiResponse,
  useRenderBusinessCaseSmsTemplateMutation,
  useRenderCustomerSmsTemplateMutation,
} from '@dms/api/core';
import {i18n} from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {VARIABLE_REGEX, handleApiError, replaceVariables} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

interface MessageFormValues {
  message: string;
}

type Props = {
  formApi: UseFormReturn<MessageFormValues>;
  control: FormControl<MessageFormValues>;
  customerId?: string;
  businessCaseId?: string;
  renderCustomerTemplate?: ReturnType<typeof useRenderCustomerSmsTemplateMutation>[0];
  renderBusinessTemplate?: ReturnType<typeof useRenderBusinessCaseSmsTemplateMutation>[0];
  templates: GetContextTemplateListApiResponse | undefined;
};

export const TemplatesChatDropdownContent = (props: Props) => {
  const navigate = useNavigate();

  const getRenderer = (template: ContextTemplateResponseBody) => {
    if (props.businessCaseId && props.renderBusinessTemplate) {
      return props.renderBusinessTemplate({
        renderBusinessCaseSmsTemplateRequestBody: {
          template: template.body,
          businessCaseId: props.businessCaseId,
        },
      });
    }

    if (props.customerId && props.renderCustomerTemplate) {
      return props.renderCustomerTemplate({
        renderCustomerSmsTemplateRequestBody: {
          template: template.body,
          customerId: props.customerId,
        },
      });
    }

    return;
  };

  const onTemplateClick = (template: ContextTemplateResponseBody) => {
    const renderer = getRenderer(template);

    if (!renderer) {
      return;
    }

    return renderer
      .unwrap()
      .then((response) => {
        props.formApi.setValue('message', replaceVariables(response.body));

        if (VARIABLE_REGEX.test(response.body)) {
          showNotification.warning(i18n.t('general.notifications.notAllPlaceholdersFilled'));
        }
      })
      .catch(handleApiError);
  };

  if (isEmpty(props.templates)) {
    return (
      <DropdownItem
        label={i18n.t('general.actions.addNewTemplate')}
        onClick={() =>
          navigate(
            composePath(settingsRoutes.messageTemplatesNew, {
              params: {type: 'chat'},
            })
          )
        }
      />
    );
  }

  return (
    <>
      {props.templates?.map((template) => (
        <DropdownItem
          label={template.name}
          key={template.id}
          onClick={() => onTemplateClick(template)}
        />
      ))}
    </>
  );
};
